import React, { useEffect, useState } from 'react'
import Slider from '../Slider'
import Text from '../../core/utils/Text'
import { CardWithColor, Input, RoundedIconButtonWithColor } from '../../styles/InvitesStyle'
import { Flex } from '../../styles/CommonStyles'
import useMyInvites from '../../core/hooks/useMyInvites'
import {p2e} from "../../core/utils/common";

const CreateInviteCodeModal = ({ setShowCreateModal }) => {
	const { createInviteCode, isCreating } = useMyInvites()

	const [sliderValue, setSliderValue] = useState(0)

	const [maxUse, setMaxUse] = useState('')

	const [actorShare, setActorShare] = useState(0)
	const [objectShare, setObjectShare] = useState(0)

	const calculateShares = () => {
		setObjectShare(parseInt(sliderValue))
		setActorShare(parseInt(100 - sliderValue))
	}

	const handleForm = (e) => {
		e.preventDefault()

		if (isCreating || maxUse < 1) {
			return false
		}

		try {
			createInviteCode({ maxUse: parseInt(maxUse), actorShare, objectShare })
			setShowCreateModal(false)
		} catch (e) {}
	}

	useEffect(calculateShares, [sliderValue])

	return (
		<div style={{ width: '100%' }} className={'px-5'}>
			<form onSubmit={handleForm}>
				<p className={'text-center'}>
					<Text tid={'specify-invite-code-shares'} />
				</p>
				<div className={'my-5'}>
					<Slider val={sliderValue} onSliderChange={(value) => setSliderValue(value)} />
				</div>
				<Flex className={'gap-5'}>
					<CardWithColor className={'grow text-center'} color={'input'}>
						<div className={'mb-1'}>
							<Text tid={'actorShare'} />:
						</div>
						<div>{actorShare}%</div>
					</CardWithColor>
					<CardWithColor className={'grow text-center'} color={'input'}>
						<div className={'mb-1'}>
							<Text tid={'objectShare'} />:
						</div>
						<div>{objectShare}%</div>
					</CardWithColor>
				</Flex>
				<div className={'my-5'}>
					<label className={'text-sm mb-1 block'}>
						<Text tid={'specify-invite-code-max-usage'} />:
					</label>
					<Input
						value={maxUse}
						onChange={(e) => {
							setMaxUse(p2e(e?.target?.value))
						}}
					/>
				</div>
				<Flex justify={'center'}>
					<RoundedIconButtonWithColor type={'submit'} textColor={'#000000'} color={'mainOrange'}>
						<Text tid={'create-invite-code'} />
					</RoundedIconButtonWithColor>
				</Flex>
			</form>
		</div>
	)
}

export default CreateInviteCodeModal
